import * as React from "react";
const SvgAttention20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm9-7a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM8.75 13.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0ZM9 5.5v5h2v-5H9Z",
      clipRule: "evenodd"
    })
  );
export default SvgAttention20Px;
